import styles from "./index.css";
import config from "../../config/common";
import { Fragment } from "react";

const addAdvert = ({ advert: Advert, items, positionFinder }) => {
  const {
    adverts: { adPosition },
  } = config;

  if (!Advert) {
    return [...items];
  }

  const positionInItemsArray = positionFinder({
    configuredPosition: adPosition,
    items,
  });

  return [
    ...items.slice(0, positionInItemsArray),
    <Fragment key="advert">
      <li className={styles.advertContainer}>
        <Advert className={styles.advert} />
      </li>
    </Fragment>,
    ...items.slice(positionInItemsArray),
  ];
};

export default addAdvert;
